export interface IEvaluatePositionOutputDto {
    zoneId: string;
    inside: boolean;
}
